export default "__VITE_ASSET__BDTkNyIB__"